// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  tagId: __t.u64().primaryKey().name("tag_id"),
  workspaceId: __t.u64().name("workspace_id"),
  subjectKind: __t.string().name("subject_kind"),
  subjectId: __t.u64().name("subject_id"),
  outcome: __t.string(),
  source: __t.string(),
  createdAt: __t.i64().name("created_at"),
});
